import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HrtApiService } from '../hrt-api/hrt-api.service';
import { OrganizationLicense } from '@brc/shared/models';

export const licensingBaseUrl = 'subscription-plan';
@Injectable({
  providedIn: 'root',
})
export class LicensingApiService {
  private readonly api = inject(HrtApiService);

  fetchLicense(): Observable<OrganizationLicense[]> {
    return this.api.getForOrganization<OrganizationLicense[]>(licensingBaseUrl);
  }

  patchLicense(id: number, payload: OrganizationLicense): Observable<OrganizationLicense> {
    return this.api.patchForOrganization<OrganizationLicense>(`${licensingBaseUrl}/${id}`, payload);
  }

  saveOrganizationLicense(payload: OrganizationLicense): Observable<OrganizationLicense> {
    const { id } = payload;

    if (id) {
      return this.patchLicense(id, payload);
    } else {
      return this.api.postForOrganization<OrganizationLicense>(`${licensingBaseUrl}`, {
        ...payload,
        organizationId: undefined,
      });
    }
  }
}
